



















































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/flux/edit/EditDartyPro.vue'
import CheckState from '@/components/shared/CheckState.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import { TypeOffre } from '@/enum/TypeOffre'
import { toSubArray } from '@/utils/groupBy'

@Component({
  name: 'ReadDartyPro',    
  components:{CheckState,Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    flux:{
      type:Object,
      default:getDefaultAloFlux()
    },
    rtbEditable:{
      type:Boolean,
      default:true      
    },
    statusEditable:{
      type:Boolean,
      default:true      
    },
    pbEditable:{
      type:Boolean,
      default:true      
    },
    tarifEditable:{
      type:Boolean,
      default:true      
    },    
    rtbVisible:{
      type:Boolean,
      default:true      
    }, 
    statusVisible:{
      type:Boolean,
      default:true      
    }, 
    pbVisible:{
      type:Boolean,
      default:true      
    },   
    tarifVisible:{
      type:Boolean,
      default:true      
    },       
  }
})
export default class ReadDartyPro extends Vue {
  
  private flux!:AloFlux
  private loading!:boolean
  private rtbEditable!:boolean
  private statusEditable!:boolean
  private pbEditable!:boolean
  private tarifEditable!:boolean
  private rtbVisible!:boolean
  private statusVisible!:boolean  
  private pbVisible!:boolean
  private tarifVisible!:boolean

  get editable() {
    return this.rtbEditable || this.statusEditable || this.pbEditable || this.tarifEditable
  }
  
  get statutCompactGroupsList(){    
    return this.$store.myGetters.statutCompactGroupsList
  }  

  get modeleTarifaire() {
    return !!this.$store.myGetters.tarifModels[this.flux.tmoId!]?this.$store.myGetters.tarifModels[this.flux.tmoId!].libelle:"Aucun"
  }

  edit() { (this.$refs.edit as Edit).edit(this.flux) }

}
